// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import { requestAccess } from "../contents/redux/actions/accessRequestActions"; 
// import styles from "./utilities/cssmodules/RequestAccess.module.css";
// import lccLogo from "../images/lcc_logo.png";

// const RequestAccess = () => {
//   const [formData, setFormData] = useState({
//     companyName: "",
//     businessRegNumber: "",
//     taxIdNumber: "",
//     businessAddress: "",
//     adminFullName: "",
//     email: "",
//     cellNumber: "",
//     secondaryCellNumber: "",
//   });

//   const [errors, setErrors] = useState({});
//   const dispatch = useDispatch();

//   // useSelector to get loading state from redux reducer
//   const { loading } = useSelector((state) => state.accessRequests);

//   const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   const phoneRegExp = /^[0-9]{7,15}$/;

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//     setErrors({ ...errors, [name]: "" }); // clear error on change
//   };

//   const validateForm = () => {
//     let newErrors = {};

//     if (!formData.companyName.trim()) newErrors.companyName = "Business/Company is required.";
//     if (!formData.businessRegNumber.trim()) newErrors.businessRegNumber = "Registration Number is required.";
//     if (!formData.taxIdNumber.trim()) newErrors.taxIdNumber = "Tax ID Number is required.";
//     if (!formData.businessAddress.trim()) newErrors.businessAddress = "Business Address is required.";
//     if (!formData.adminFullName.trim()) newErrors.adminFullName = "Administrator's Full Name is required.";

//     if (!formData.email.trim()) {
//       newErrors.email = "Email is required.";
//     } else if (!emailRegExp.test(formData.email)) {
//       newErrors.email = "Invalid email format.";
//     }

//     if (!formData.cellNumber.trim()) {
//       newErrors.cellNumber = "Primary cell number is required.";
//     } else if (!phoneRegExp.test(formData.cellNumber)) {
//       newErrors.cellNumber = "Invalid phone number.";
//     }

//     // Secondary number validation (optional)
//     if (formData.secondaryCellNumber.trim() && !phoneRegExp.test(formData.secondaryCellNumber)) {
//       newErrors.secondaryCellNumber = "Invalid phone number.";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       toast.error("Please correct the highlighted errors.");
//       return;
//     }

//     // Map formData to API format
//     const requestData = {
//       companyName: formData.companyName,
//       businessRegistrationNumber: formData.businessRegNumber,
//       tin: formData.taxIdNumber,
//       businessAddress: formData.businessAddress,
//       contactPerson: formData.adminFullName,
//       email: formData.email,
//       cellNumber: formData.cellNumber,
//       secondaryCellNumber: formData.secondaryCellNumber,
//     };

//     // Dispatch redux action
//     dispatch(requestAccess(requestData));

//     // Reset form after submission
//     setFormData({
//       companyName: "",
//       businessRegNumber: "",
//       taxIdNumber: "",
//       businessAddress: "",
//       adminFullName: "",
//       email: "",
//       cellNumber: "",
//       secondaryCellNumber: "",
//     });
//     setErrors({});
//   };

//   return (
//     <div className={styles.request_access_wrapper}>
//       <div className={styles.action_component_header}>
//         <div className={styles.action_component_header_logo}>
//           <img src={lccLogo} alt="lcc logo" className={styles.logo_1} />
//         </div>
//         <div className={styles.action_component_header_text}>
//           Liberia Chamber of Commerce - Access Request Form
//         </div>
//       </div>

//       <h1>Request access to the platform by filling out the form below</h1>

//       <form className={styles.request_access_form} onSubmit={handleSubmit}>
//         {
//         [
//           { label: "Business/Company *", name: "companyName", type: "text", placeholder: "Enter your business or company name" },
//           { label: "Business Registration Number *", name: "businessRegNumber", type: "text", placeholder: "Enter registration number" },
//           { label: "Tax Identification Number *", name: "taxIdNumber", type: "text", placeholder: "Enter tax ID number" },
//           { label: "Business Address *", name: "businessAddress", type: "text", placeholder: "Enter business address" },
//           { label: "Administrator's Full Name *", name: "adminFullName", type: "text", placeholder: "Enter administrator's full name" },
//           { label: "Valid Email Address *", name: "email", type: "email", placeholder: "Enter valid email" },
//           { label: "Primary Cell Number *", name: "cellNumber", type: "tel", placeholder: "Enter primary cell number" },
//           { label: "Secondary Cell Number (Optional)", name: "secondaryCellNumber", type: "tel", placeholder: "Enter secondary cell number" },
//         ]
//         .map(({ label, name, type, placeholder, fullWidth }) => (
//           <div
//             key={name}
//             className={`${styles.field_group} ${fullWidth ? styles.full_width_field : ""}`}
//           >
//             <label>{label}</label>
//             <input
//               type={type}
//               name={name}
//               value={formData[name]}
//               onChange={handleChange}
//               placeholder={placeholder}
//               className={errors[name] ? styles.error_input : ""}
//             />
//             {errors[name] && <span className={styles.error_text}>{errors[name]}</span>}
//           </div>
//         ))}

//         <button type="submit" disabled={loading}>
//           {loading ? "Submitting..." : "Submit Request"}
//         </button>
//       </form>
//     </div>
//   );
// };

// export default RequestAccess;















import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { requestAccess } from "../contents/redux/actions/accessRequestActions"; 
import styles from "./utilities/cssmodules/RequestAccess.module.css";
import lccLogo from "../images/lcc_logo.png";

const RequestAccess = () => {
  const [formData, setFormData] = useState({
    companyName: "",
    businessRegNumber: "",
    taxIdNumber: "",
    businessAddress: "",
    adminFullName: "",
    email: "",
    cellNumber: "",
    secondaryCellNumber: "",
  });

  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  // useSelector to get loading state from redux reducer
  const { loading } = useSelector((state) => state.accessRequests);

  const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegExp = /^[0-9]{7,15}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" }); // clear error on change
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.companyName.trim()) newErrors.companyName = "Business/Company is required.";
    if (!formData.businessRegNumber.trim()) newErrors.businessRegNumber = "Business registration number is required.";
    if (!formData.taxIdNumber.trim()) newErrors.taxIdNumber = "Tax ID number is required.";
    if (!formData.businessAddress.trim()) newErrors.businessAddress = "Business address is required.";
    if (!formData.adminFullName.trim()) newErrors.adminFullName = "Administrator's full name is required.";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!emailRegExp.test(formData.email)) {
      newErrors.email = "Invalid email format.";
    }

    if (!formData.cellNumber.trim()) {
      newErrors.cellNumber = "Primary cell number is required.";
    } else if (!phoneRegExp.test(formData.cellNumber)) {
      newErrors.cellNumber = "Invalid phone number.";
    }

    // Secondary number validation (optional)
    if (formData.secondaryCellNumber.trim() && !phoneRegExp.test(formData.secondaryCellNumber)) {
      newErrors.secondaryCellNumber = "Invalid phone number.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please correct the highlighted errors.");
      return;
    }

    // Map formData to API format
    const requestData = {
      companyName: formData.companyName,
      businessRegistrationNumber: formData.businessRegNumber,
      tin: formData.taxIdNumber,
      businessAddress: formData.businessAddress,
      contactPerson: formData.adminFullName,
      email: formData.email,
      cellNumber: formData.cellNumber,
      secondaryCellNumber: formData.secondaryCellNumber,
    };

    // Dispatch redux action
    dispatch(requestAccess(requestData));

    // Reset form after submission
    setFormData({
      companyName: "",
      businessRegNumber: "",
      taxIdNumber: "",
      businessAddress: "",
      adminFullName: "",
      email: "",
      cellNumber: "",
      secondaryCellNumber: "",
    });
    setErrors({});
  };

  const fields = [
    { label: "Business/Company", name: "companyName", type: "text", placeholder: "Enter your business or company name", required: true },
    { label: "Business Registration Number", name: "businessRegNumber", type: "text", placeholder: "Enter registration number", required: true },
    { label: "Tax Identification Number", name: "taxIdNumber", type: "text", placeholder: "Enter tax ID number", required: true },
    { label: "Business Address", name: "businessAddress", type: "text", placeholder: "Enter business address", required: true },
    { label: "Administrator's Full Name", name: "adminFullName", type: "text", placeholder: "Enter administrator's full name", required: true },
    { label: "Valid Email Address", name: "email", type: "email", placeholder: "Enter valid email", required: true },
    { label: "Primary Cell Number", name: "cellNumber", type: "tel", placeholder: "Enter primary cell number", required: true },
    { label: "Secondary Cell Number (Optional)", name: "secondaryCellNumber", type: "tel", placeholder: "Enter secondary cell number", required: false },
  ];

  return (
    <div className={styles.request_access_wrapper}>
      <div className={styles.action_component_header}>
        <div className={styles.action_component_header_logo}>
          <img src={lccLogo} alt="lcc logo" className={styles.logo_1} />
        </div>
        <div className={styles.action_component_header_text}>
          Liberia Chamber of Commerce - Access Request Form
        </div>
      </div>

      <h1>Request access to the platform by filling out the form below</h1>

      <form className={styles.request_access_form} onSubmit={handleSubmit}>
        {fields.map(({ label, name, type, placeholder, fullWidth, required }) => (
          <div
            key={name}
            className={`${styles.field_group} ${fullWidth ? styles.full_width_field : ""}`}
          >
            <label>
              {label} {required && <span className={styles.required_star}>*</span>}
            </label>
            <input
              type={type}
              name={name}
              value={formData[name]}
              onChange={handleChange}
              placeholder={placeholder}
              className={errors[name] ? styles.error_input : ""}
            />
            {errors[name] && <span className={styles.error_text}>{errors[name]}</span>}
          </div>
        ))}

        <button type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Submit request"}
        </button>
      </form>
    </div>
  );
};

export default RequestAccess;
